"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FilePreviewCard {
    handleMenuSelect(event) {
        var _a;
        const index = (_a = event.checked) === null || _a === void 0 ? void 0 : _a[0];
        const eventName = this.input.menuActions &&
            index !== undefined &&
            index in this.input.menuActions
            ? this.input.menuActions[index].event
            : null;
        if (eventName) {
            this.emit("menu-action", eventName, event);
        }
        else {
            this.emit("delete");
        }
    }
}
module.exports = FilePreviewCard;
